import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { DocmanFileModel } from '../services/docman.model.file';
import { UiService } from '../../../core/services/core.ui.service';

@Component({
  selector: 'file-version-edit-modal',
  template: require('./file.version.edit.modal.html')
})
export class FileVersionEditModalComponent implements OnInit {
  @Input() file: any;
  @Input() fileVersion: any;

  @Output() onEdit = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();

  constructor(
    private docmanFileModel: DocmanFileModel,
    private uiService: UiService
  ) {}

  ngOnInit(): void {
  }

  editFileVersion(): void {
    const _fileVersion = {
      id: this.fileVersion.id,
      docmanFile: this.file.id,
      changes: this.fileVersion.changes
    };

    this.docmanFileModel.saveFileVersion(_fileVersion).then(
      () => {
        this.onEdit.emit();
      },
      () => {
        this.onClose.emit();
      }
    );
  }
}
